
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import GoogleAnalytics from '../components/GoogleAnalytics';



function Punetomumbaiairportcab() {



  const cardData =
  {
    keyword: ' Pune To Mumbai Airport Cab',
    heading: 'SHREE Tours & Travels: Pune To Mumbai Airport Cab',
    headingDescription: 'SHREE Tours & Travels offers Pune to Mumbai Airport Cab service, ensuring a smooth, comfortable and hassle-free travel experience for business travelers, families and tourists. Whether you need a one-way drop, round trip, or late-night airport transfer, our well-maintained fleet guarantees timely and reliable service. With professional chauffeurs, affordable pricing and 24/7 availability, we make your journey from Pune to Mumbai Airport (Chhatrapati Shivaji Maharaj International Airport) stress-free and convenient. Choose SHREE Tours & Travels for the best Pune to Mumbai Airport Cab service.',

    top: 'Top Places to Visit in Mumbai with SHREE Tours & Travels',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "Shaniwar Wada is a historic fortification in Pune that was once the seat of the Peshwas of the Maratha Empire. Built in 1732, this grand palace features intricately designed gates, massive walls and remnants of the royal residence. The site is famous for its rich history, evening light and sound show and legends of being haunted, making it a fascinating place for history enthusiasts."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Aga Khan Palace is a magnificent historical landmark in Pune, known for its association with India's freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi and his associates during the Quit India Movement. The palace features beautiful Italian arches, sprawling gardens and a museum displaying photographs and personal belongings of Gandhi, making it a must-visit for history lovers."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Situated atop a hill, Sinhagad Fort is one of Pune’s most popular trekking destinations. The fort has great historical significance, as it was the site of the famous battle of 1670 between the Marathas and the Mughals. Visitors can explore the ancient ruins, enjoy breathtaking views of the Sahyadri hills and relish local delicacies like Kanda Bhaji (onion fritters) and Pithla Bhakri (a traditional Maharashtrian meal)."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "The Pataleshwar Cave Temple is a rock-cut temple dedicated to Lord Shiva, dating back to the 8th century. Carved out of a single rock, this ancient temple features massive stone pillars and intricate carvings. Located in the heart of the city, it offers a peaceful retreat for devotees and architecture enthusiasts."
    },
    {
        "title": "Rajiv Gandhi Zoological Park",
        "description": "Spread over 130 acres, the Rajiv Gandhi Zoological Park is home to a variety of wildlife, including tigers, leopards, snakes and elephants. The park also includes the Katraj Snake Park, which houses various reptile species. It's a great destination for families and nature lovers looking to explore Pune’s rich biodiversity."
    },
    {
        "title": "Osho Ashram",
        "description": "The Osho International Meditation Resort in Pune is a world-renowned spiritual center attracting visitors seeking peace and self-discovery. The ashram offers meditation sessions, wellness programs and serene gardens for relaxation. It's a unique place to experience mindfulness and inner tranquility in the bustling city."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Inspired by the Korakuen Garden in Japan, the Pune Okayama Friendship Garden is a beautifully landscaped park featuring lush greenery, flowing streams and picturesque bridges. Spread across 10 acres, this peaceful garden is an ideal spot for nature lovers and photography enthusiasts looking for a serene escape in Pune."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "Dedicated to Lord Ganesha, the Dagdusheth Halwai Ganpati Temple is one of the most famous temples in Maharashtra. The temple attracts thousands of devotees, especially during the Ganesh Chaturthi festival. Its grand idol adorned with gold ornaments and vibrant ambiance make it a must-visit spiritual destination in Pune."
    },
    {
        "title": "Khadakwasla Dam",
        "description": "Khadakwasla Dam is a scenic getaway near Pune, known for its breathtaking views and tranquil surroundings. Visitors can enjoy picnics, local street food and sunset views along the water. It is an excellent spot for nature lovers and those looking to escape the city’s hustle and bustle."
    },
    {
        "title": "Lal Mahal",
        "description": "The Lal Mahal is an important historical site associated with Chhatrapati Shivaji Maharaj. Originally built in 1630, this palace was where Shivaji spent his childhood. The museum inside showcases paintings, artifacts and stories of the great Maratha warrior, making it a must-visit for those interested in Maharashtra’s glorious past."
    }
],  
    
            
"services": [
    {
      "name": "Mumbai to Pune Taxi",
      "description": "Book a reliable taxi from Mumbai to Pune with SHREE Tours & Travels. Enjoy a comfortable and hassle-free journey in our well-maintained vehicles."
    },
    {
      "name": "Mumbai to Pune Cab Service",
      "description": "Looking for a professional Cab service from Mumbai to Pune? We offer one-way and round-trip options with experienced drivers for a smooth travel experience."
    },
    {
      "name": "Mumbai to Pune One-Way Cab",
      "description": "Need a one-way taxi from Mumbai to Pune? Enjoy a cost-effective and comfortable ride with SHREE Tours & Travels, with no hidden charges."
    },
    {
      "name": "Mumbai to Pune Round Trip Taxi",
      "description": "Planning a round trip from Mumbai to Pune? We offer flexible round-trip taxi options to suit your travel schedule at affordable rates."
    },
    {
      "name": "Affordable Mumbai to Pune Cab",
      "description": "Get affordable Cab services from Mumbai to Pune without compromising on comfort. Travel comfortably with reliable and well-maintained vehicles."
    },
    {
      "name": "Private Taxi for Pune from Mumbai",
      "description": "Book a private taxi from Mumbai to Pune for a personalized and comfortable journey. Enjoy a private and peaceful ride tailored to your schedule."
    },
    {
      "name": "Pune Travel from Mumbai by Cab",
      "description": "Travel from Mumbai to Pune with ease by booking a Cab. Our expert drivers ensure a smooth journey with timely pickups and drop-offs."
    },
    {
      "name": "Group Travel to Pune by Cab",
      "description": "Traveling with a group? Book a spacious Cab for your journey from Mumbai to Pune. We offer comfortable vehicles for large groups and families."
    },
    {
      "name": "Book Mumbai to Pune Car",
      "description": "Rent a car for your Mumbai to Pune journey with ease. Choose from sedans, SUVs, or tempo travelers for a convenient and comfortable ride."
    },
    {
      "name": "Mumbai to Pune Cab Booking",
      "description": "Book a Cab from Mumbai to Pune effortlessly. Enjoy a reliable and convenient service with timely pickups, professional drivers and affordable rates."
    },
    {
      "name": "Mumbai to Pune Luxury Taxi",
      "description": "Experience a premium travel experience with our luxury taxi service from Mumbai to Pune. Choose high-end vehicles like the Innova Crysta or Mercedes for ultimate comfort."
    },
    {
      "name": "Mumbai to Pune Budget Cab",
      "description": "Looking for an affordable travel option? We offer budget-friendly Cab services from Mumbai to Pune without compromising on quality and comfort."
    },
    {
      "name": "Mumbai to Pune Family Taxi",
      "description": "Traveling with family? Our family-friendly taxi service ensures a safe, comfortable and hassle-free ride from Mumbai to Pune."
    },
    {
      "name": "Pune to Mumbai Taxi Rental",
      "description": "Looking to rent a taxi for a journey from Pune to Mumbai? We offer reliable taxi rental services with experienced drivers for a smooth trip."
    }
  ],

  "tableData": [
    ["- Mumbai to Pune Taxi", "- Mumbai to Pune Cab Service"],
    ["- Mumbai to Pune One-Way Cab", "- Mumbai to Pune Round Trip Taxi"],
    ["- Affordable Mumbai to Pune Cab", "- Private Taxi for Pune from Mumbai"],
    ["- Pune Travel from Mumbai by Cab", "- Group Travel to Pune by Cab"],
    ["- Book Mumbai to Pune Car", "- Mumbai to Pune Cab Booking"],
    ["- Mumbai to Pune Luxury Taxi", "- Mumbai to Pune Budget Cab"],
    ["- Mumbai to Pune Family Taxi", "- Pune to Mumbai Taxi Rental"]
  ],




  
  whychoose: [
    {
      "WhyChooseheading": "Comfortable and Relaxing Ride",
      "WhyChoosedescription": "Our Mumbai to Pune Cab service offers a comfortable and relaxing journey. With spacious, clean and air-conditioned vehicles, you can enjoy a smooth ride between the two cities. Whether you're traveling for business, leisure, or personal reasons, we ensure a stress-free and enjoyable trip."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our experienced drivers are familiar with the best routes from Mumbai to Pune, ensuring you reach your destination safely and on time. With a focus on safety and customer satisfaction, our drivers prioritize your comfort and convenience throughout the journey."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer affordable and transparent pricing for your Mumbai to Pune trip, with no hidden fees. Our competitive rates provide great value while maintaining high standards of service. Whether you need a one-way or round-trip ride, you can rely on us for budget-friendly options."
    },
    {
      "WhyChooseheading": "Well-Maintained Vehicles",
      "WhyChoosedescription": "All our vehicles are regularly serviced and maintained to the highest standards. From mechanical inspections to cleanliness, we ensure that each car is in optimal condition for your journey. Enjoy a safe, comfortable and worry-free ride with our well-maintained fleet."
    },
    {
      "WhyChooseheading": "Easy and Convenient Booking Process",
      "WhyChoosedescription": "Booking a Mumbai to Pune Cab with SHREE Tours & Travels is quick and easy. You can book online through our user-friendly platform, or contact our customer service team for assistance. Whether you're booking in advance or last minute, our process is designed to be hassle-free."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "We offer 24/7 availability for your Mumbai to Pune Cab needs. No matter the time of day or night, we are ready to serve you. Whether you need a morning departure or a late-night transfer, our round-the-clock service ensures we're always available to meet your schedule."
    },
    {
      "WhyChooseheading": "Local Insights and Recommendations",
      "WhyChoosedescription": "Our drivers are knowledgeable about the best routes and local attractions along the way from Mumbai to Pune. If you're interested in stopping for sightseeing or need recommendations on places to visit, they can provide valuable insights to make your trip even more enjoyable."
    },
    {
      "WhyChooseheading": "Customer Satisfaction Guarantee",
      "WhyChoosedescription": "At SHREE Tours & Travels, we are committed to providing exceptional service. We prioritize customer satisfaction and ensure that your Mumbai to Pune Cab ride is comfortable, safe and on time. With our dedication to quality service, we guarantee a hassle-free and pleasant journey every time."
    }
  ]
  
  
  
  
  
  
  
  
  
  



        
  }

  const faqData = [
    {
        question: "How can I book a Cab from Mumbai to Pune?",
        answer: "You can easily book your Mumbai to Pune Cab through our website or by calling our customer service for assistance."
    },
    {
        question: "What types of Cabs do you offer for the Mumbai to Pune route?",
        answer: "We offer a variety of vehicles for the Mumbai to Pune journey, including sedans, SUVs and MPVs, to suit your preferences and group size."
    },
    {
        question: "Are the rental rates from Mumbai to Pune inclusive of fuel?",
        answer: "Fuel charges may vary depending on the rental agreement. Detailed pricing information will be provided during the booking process."
    },
    {
        question: "Can I book a Cab for a one-way trip from Mumbai to Pune?",
        answer: "Yes, we offer one-way rental options for your Mumbai to Pune trip."
    },
    {
        question: "Do you provide drivers with the rental Cab for the Mumbai to Pune trip?",
        answer: "Yes, all our Cabs come with experienced drivers who are familiar with the route to ensure a safe and comfortable journey."
    },
    {
        question: "What is your cancellation policy for a Mumbai to Pune Cab booking?",
        answer: "We offer a flexible cancellation policy. Please contact us for detailed information specific to your booking."
    },
    {
        question: "What payment methods do you accept for the Mumbai to Pune Cab booking?",
        answer: "We accept various payment methods, including cash, credit/debit cards and mobile wallets for your convenience."
    },
    {
        question: "Are the vehicles insured for the Mumbai to Pune trip?",
        answer: "Yes, all our vehicles come with insurance coverage for your safety while traveling."
    },
    {
        question: "Can I request a child seat for my Cab from Mumbai to Pune?",
        answer: "Yes, child seats can be arranged upon request at the time of booking."
    },
    {
        question: "What is your contact information for booking a Cab from Mumbai to Pune?",
        answer: "For bookings and inquiries, you can reach us at: +91 9594917913."
    }
];

const testimonialsData = [
    {
        text: 'The Mumbai to Pune trip was smooth and comfortable! The driver was punctual and the vehicle was well-maintained.',
        name: 'Mr. Sandeep Agarwal',
    },
    {
        text: 'I had a wonderful experience with SHREE Tours & Travels. The driver was professional and made the journey from Mumbai to Pune very pleasant.',
        name: 'Miss. Aditi Mehta',
    }
];










  
  
  


  


  const contactData = {
     heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9594917913",

    ],
    email: "booking@shreecabs24.com"
  };


    const Images = [
    {
        place: "/images/keyword/1.jpg",
        text: "Pune to Kolhapur Cab",
        link: "/Pune-to-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/2.jpg",
        text: "Pune to Mumbai Cab",
        link: "/Pune-to-Mumbai-Cab",
    },
    {
        place: "/images/keyword/3.jpg",
        text: "Pune to Sangli Cab",
        link: "/Pune-to-Sangli-Cab",
    },
    {
        place: "/images/keyword/4.jpg",
        text: "Pune to Mahabaleshwar Cab",
        link: "/Pune-to-Mahabaleshwar-Cab",
    },
    {
        place: "/images/keyword/5.jpg",
        text: "Pune to Bhimashankar Cab",
        link: "/Pune-to-Bhimashankar-Cab",
    },
    {
        place: "/images/keyword/6.jpg",
        text: "Pune to Shirdi Cab",
        link: "/Pune-to-Shirdi-Cab",
    },
    {
        place: "/images/keyword/7.jpg",
        text: "Pune to Nashik Cab",
        link: "/Pune-to-Nashik-Cab",
    },
    {
        place: "/images/keyword/8.jpg",
        text: "Pune Airport Pickup and Drop",
        link: "/Pune-Airport-Pickup-and-Drop",
    },
    {
        place: "/images/keyword/9.jpg",
        text: "Pune To Mumbai Airport Cab",
        link: "/Pune-To-Mumbai-Airport-Cab",
    },
    {
        place: "/images/keyword/10.jpg",
        text: "Mumbai To Pune Cab",
        link: "/Mumbai-To-Pune-Cab",
    },
    {
        place: "/images/keyword/12.jpg",
        text: "Mumbai To Kolhapur Cab",
        link: "/Mumbai-To-Kolhapur-Cab",
    },
    {
        place: "/images/keyword/13.jpg",
        text: "Mumbai To Shirdi Cab",
        link: "/Mumbai-To-Shirdi-Cab",
    },
    {
        place: "/images/keyword/14.jpg",
        text: "Mumbai To Nashik Cab",
        link: "/Mumbai-To-Nashik-Cab",
    },
    {
        place: "/images/keyword/15.jpg",
        text: "Mumbai Airport To Pune Cab",
        link: "/Mumbai-Airport-To-Pune-Cab",
    },
    {
        place: "/images/keyword/16.jpg",
        text: "Kolhapur To Pune Cab",
        link: "/Kolhapur-To-Pune-Cab",
    },
    {
        place: "/images/keyword/17.jpg",
        text: "Kolhapur To Mumbai Cab",
        link: "/Kolhapur-To-Mumbai-Cab",
    },
    {
        place: "/images/keyword/18.jpg",
        text: "Sangli To Pune Cab",
        link: "/Sangli-To-Pune-Cab",
    },
    {
        place: "/images/keyword/19.jpg",
        text: "One Way Taxi in Pune",
        link: "/One-Way-Taxi-in-Pune",
    },
    {
        place: "/images/keyword/20.jpg",
        text: "Best Cab service in Pune",
        link: "/Best-Cab-Service-in-Pune",
    },
    {
        place: "/images/keyword/21.jpg",
        text: "Outstation Cabs Pune",
        link: "/Outstation-Cabs-Pune",
    },
    {
        place: "/images/keyword/22.jpg",
        text: "Swift Dzire Hire in Pune",
        link: "/Swift-Dzire-Hire-in-Pune",
    },
    {
        place: "/images/keyword/23.jpg",
        text: "Xcent Hyundai On Rent in Pune",
        link: "/Xcent-Hyundai-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/24.jpg",
        text: "Nexa Ciaz On Rent in Pune",
        link: "/Nexa-Ciaz-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/25.jpg",
        text: "Honda City On Rent In Pune",
        link: "/Honda-City-On-Rent-In-Pune",
    },
    {
        place: "/images/keyword/26.jpg",
        text: "Ertiga On Rent in Pune",
        link: "/Ertiga-On-Rent-in-Pune",
    },
    {
        place: "/images/keyword/27.jpg",
        text: "Innova Cab for Outstation in Pune",
        link: "/Innova-Cab-for-Outstation-in-Pune",
    },
];

  
const images = [
    { src: "/images/ourfleet/1.webp", alt: "Image 1" },
    { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
    { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

];


const schemaData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SHREE Tours & Travels",
  "description": "Book a comfortable and reliable Pune to Mumbai airport Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Your office address here",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "telephone": "+91-9594917913",
  "url": "https://shreetoursandtravels.in",
  "logo": "https://shreetoursandtravels.in/img/logo.jpg",
  "image": [
    "https://shreetoursandtravels.in/img/pune-to-mumbai-airport-cab.jpg",
    "https://shreetoursandtravels.in/img/mumbai-airport-cab-service.jpg"
  ],
  "priceRange": "₹2500 - ₹4000",
  "offers": {
    "@type": "Offer",
    "url": "https://shreetoursandtravels.in/pune-to-mumbai-airport-cab-service",
    "priceCurrency": "INR",
    "price": 3000,
    "priceValidUntil": "2025-12-31"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": 4.8,
    "reviewCount": 1200
  },
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Ravi Kulkarni"
      },
      "datePublished": "2024-10-10",
      "reviewBody": "The service from Pune to Mumbai Airport was excellent. The driver was punctual and very professional. The ride was smooth and comfortable."
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Anjali Desai"
      },
      "datePublished": "2024-11-15",
      "reviewBody": "Highly recommend SHREE Tours & Travels for airport transfers. The car was clean and I reached Mumbai airport on time without any hassle."
    }
  ],
  "serviceArea": {
    "@type": "Place",
    "name": "Pune to Mumbai Airport Cab Service",
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": 18.5812,  // Pune latitude
      "longitude": 73.9147  // Pune longitude
    }
  },
  "availableChannel": {
    "@type": "ServiceChannel",
    "serviceUrl": "https://shreetoursandtravels.in/pune-to-mumbai-airport-cab-service"
  },
  "keywords": "Pune to Mumbai Airport Taxi, Pune to Mumbai Airport Cab Booking, Pune to Mumbai Airport One-Way Taxi, Pune to Mumbai Airport Round Trip Cab, Affordable Pune to Mumbai Airport Cab, Private Taxi for Mumbai Airport from Pune, Mumbai Airport Travel from Pune by Cab, Group Travel to Mumbai Airport by Cab, Book Pune to Mumbai Airport Car, Mumbai Airport Cab Rental, Pune to Mumbai Airport Drop, Mumbai Airport Pickup Service from Pune, Luxury Taxi for Mumbai Airport, Mumbai Airport to Pune Taxi Service"
};



  return (
    <div>
      <GoogleAnalytics/>
    <Helmet>
  <title>Pune to Mumbai Airport Cab Service | SHREE Tours & Travels | Call: +91 9594917913</title>
  <meta name="description" content="Book a comfortable and reliable Pune to Mumbai airport Cab with SHREE Tours & Travels. Enjoy affordable fares, one-way and round-trip options. Call +91 9594917913 for booking!" />
  <meta name="keywords" content="Pune to Mumbai Airport Taxi, Pune to Mumbai Airport Cab Booking, Pune to Mumbai Airport One-Way Taxi, Pune to Mumbai Airport Round Trip Cab, Affordable Pune to Mumbai Airport Cab, Private Taxi for Mumbai Airport from Pune, Mumbai Airport Travel from Pune by Cab, Group Travel to Mumbai Airport by Cab, Book Pune to Mumbai Airport Car, Mumbai Airport Cab Rental, Pune to Mumbai Airport Drop, Mumbai Airport Pickup Service from Pune, Luxury Taxi for Mumbai Airport, Mumbai Airport to Pune Taxi Service" />
  <meta name="robots" content="index, follow" />
  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>

    <section
        className="page-title"
        style={{ backgroundImage: 'url(images/hero.jpg)' }}
      >
        <div className="auto-container">
          <div className="title-outer text-center">
            <h1 className="title">{cardData.keyword} </h1>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
         <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/9.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#0310a8', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <div className='pb-3'>
                <button
                  className="p-3 text-white fw-bold borderrr bg-header"
                  onClick={() => {
                    window.location.href = '/booking';
                  }}
                >
                  Book Your Cab
                </button>
              </div>
              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
            <BusRatesTable />

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for SHREE Tours & Travels </h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                {/* <CustomCarousel items={carouselItems} options={carouselOptions} /> */}

                <TestimonialKeyword testimonials={testimonialsData} />

                
              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
    {Images.map((e) => {
        return (
            <div className="box1">
                <a href={e.link} className="d-flex justify-content-around align-items-center">
                    <div className="b1">
                        <img src={e.place} alt="img" />
                    </div>
                    <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                    </div>
                </a>
            </div>
        );
    })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Fleet</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}
               
                </div>
              </div>

             <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #0310a8',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#0310a8' }}>
                      <div>
                      <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>
                      
                      <div className=''>
                        <a href="tel:+919594917913" className="d-block  text-white">
                        <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 9594917913
                      </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:booking@shreecabs24.com" className=" text-white d-block">
                        <i className="fas fa-envelope darkcolorrr"></i> booking@shreecabs24.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      
                      <div className='rounded ' style={{ backgroundColor: '#0310a8' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                        <i className="fas fa-map-marker-alt darkcolorrr"></i>  SHREE Tours & Travels<br />
                          Maharashtra Co-Operative Housing Society,
                          Yerawada, Pune, Maharashtra India - 411006
                            
                         
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



            </div>
          </div>
        </div>
      </section>






    </div>
  );
}

export default Punetomumbaiairportcab;